import PageTitle from "PFComponents/page/page_title";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import AddRoleButton from "./add_role_button";
import BecomeCoownerButton from "./become_coowner_button";
import css from "./details_header.less";

const DetailsHeader = ({
  activityId,
  canCreateRoles,
  canBecomeCoowner,
  templateName,
  roleKey,
  nameAndId
}) => {
  const { t } = useTranslation("activities");
  return (
    <div className={css.wrapper}>
      <PageTitle
        qaId="ActivityDetails.title"
        actions={
          <>
            {canBecomeCoowner && <BecomeCoownerButton templateName={templateName} />}
            {canCreateRoles && (
              <AddRoleButton activityId={activityId} style={{ height: 40 }} roleKey={roleKey} />
            )}
          </>
        }
      >
        <div className={css.header}>
          <span>{t("show.details.header", { templateName, activityName: nameAndId.name })}</span>
          {nameAndId.id && <span className={css.id}>{t("show.details.id", { id: nameAndId.id })}</span>}
        </div>
      </PageTitle>
    </div>
  );
};

DetailsHeader.propTypes = {
  canCreateRoles: PropTypes.bool,
  canBecomeCoowner: PropTypes.bool,
  activityId: PropTypes.number,
  templateName: PropTypes.string,
  roleKey: PropTypes.string,
  nameAndId: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number
  })
};

export default DetailsHeader;
